import { render, staticRenderFns } from "./watched.vue?vue&type=template&id=4f9a5829"
import script from "./watched.vue?vue&type=script&lang=js"
export * from "./watched.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports